/**
 * Js for content drip on frontend
 *
 * @since 4.0.3
 * @version 1.0.0
 */

import { __ } from '@wordpress/i18n';

class lpContentDrip {
	elContentDrip;
	totalTimeRemaining;

	counterTimeToReload() {
		if ( ! this.totalTimeRemaining ) return;

		const inputReload = this.totalTimeRemaining;
		if (inputReload === null) return;

		const timeReload = inputReload.value;
		if ( timeReload > 0 && timeReload <= 86400000 ) {
			setTimeout(function () {
				window.location.reload();
			}, timeReload );
		}
	}

	countDownTime() {
		if ( ! this.totalTimeRemaining ) return;

		let elMinute = this.elContentDrip.querySelector('.minute');
		let elSecond = this.elContentDrip.querySelector('.second');
		let milliseconds = this.totalTimeRemaining.value;

		const count = setInterval(	() => {
			milliseconds -= 1000;

			if ( milliseconds < 60000 ) {
				const second = milliseconds / 1000;
				if ( elMinute ) {
					elMinute.textContent = second;
				} else if ( elSecond ) {
					elSecond.textContent = second;
				}

				elMinute.textContent += __('seconds', 'learnpress-content-drip');
			}

			if ( milliseconds < 0 ) {
				clearInterval(count);
			}
		}, 1000 )
	}

	domLoaded() {
		this.elContentDrip = document.querySelector('#learn-press-content-item');
		if ( ! this.elContentDrip ) return;
		this.totalTimeRemaining = this.elContentDrip.querySelector('#ctd-time-remaining');
		this.counterTimeToReload();
		this.countDownTime();
	}
}

window.jsContentDrip = new lpContentDrip();
document.addEventListener('DOMContentLoaded', function () {
	window.jsContentDrip.domLoaded();
});
